import { Check } from '@mui/icons-material';
import { Box } from '@mui/material';
import { get } from 'lodash';

const AliasColumn = ({ path = ['alias'], autoAlias = false, ...props } = { path: ['alias'] }) => {
    const rowHasAlias = row => !!get(row, path) || (autoAlias && !!row.auto_alias);

    return {
        field: 'alias',
        hideable: true,
        resizable: false,
        width: 100,
        headerName: 'Aliased',
        type: 'boolean',
        headerAlign: 'center',
        align: 'center',
        headerClassName: 'non-resizable',
        valueGetter: ({ row }) => rowHasAlias(row),
        renderCell: ({ row }) => {
            if (rowHasAlias(row)) {
                return (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <Check />
                    </Box>
                );
            }
            return '';
        },
        ...props,
    };
};

export default AliasColumn;
